import React, { useMemo, useState } from 'react'
import translate from 'core/translate'
import { Typography } from 'atoms/Typography'
import { cn } from 'ethcss'
import styles from './deviceSettings__kioskMode.jcss'
import EditText from 'blocks.simple/editText/editText'
import Dropdown from 'blocks.simple/dropdown/dropdown'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.simple/icon/icon.theme'
import { SwitchButton } from '../../../atoms/SwitchButton'

const TIME_LIMIT_OPTIONS = [
    { id: 0, name: translate('disable') },
    { id: 1, name: `1 ${translate('min')}` },
    { id: 2, name: `2 ${translate('min')}` },
    { id: 3, name: `3 ${translate('min')}` },
]

const DeviceSettingsKioskMode = (p_: {
    enabled: boolean
    value: {
        controlsMode: string
        kioskMode:
            | {
                  invalidCodeLimit?: number | null
                  exitCode?: string | null
                  isUseCodeForKioskMode?: boolean | null
              }
            | undefined
    }
    onChange: (value: any, field: string) => void
}) => {
    const isShowCode = useMemo(() => {
        return p_.value.kioskMode?.isUseCodeForKioskMode ?? true
    }, [p_.value.kioskMode])
    const [showIcon, setShowIcon] = useState(true)

    const isValid = useMemo(() => {
        const len = p_.value.kioskMode?.exitCode?.length ?? '95224'.length
        return len === 4 || len === 5
    }, [p_.value.kioskMode])

    if (!p_.enabled) {
        return null
    }

    return (
        <div>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.value.controlsMode === 'kiosk'}
                    onChange={() => {
                        p_.onChange(p_.value.controlsMode === 'kiosk' ? 'system' : 'kiosk', 'controlsMode')
                    }}
                    className={`test-settings-toggle_${p_.value.controlsMode === 'kiosk' ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('kioskMode')}
                    </Typography>
                </div>
            </div>
            {p_.value.controlsMode === 'kiosk' && (
                <>
                    <div className={styles.switchWrapper}>
                        <SwitchButton
                            checked={isShowCode}
                            onChange={() => {
                                p_.onChange(
                                    {
                                        ...p_.value.kioskMode,
                                        isUseCodeForKioskMode: !isShowCode,
                                    },
                                    'kioskMode'
                                )
                            }}
                            className={`test-settings-toggle_${isShowCode ? 'enabled' : 'disabled'}`}
                        />
                        <div className={cn(styles.switchCaption)}>
                            <Typography className={cn(styles.title)} type="title">
                                {translate('useCodeToKioskModeExit')}
                            </Typography>
                        </div>
                    </div>
                    {isShowCode && (
                        <>
                            <EditText
                                label={translate('codeToKioskModeExit')}
                                containerClass={cn(styles.inputWrapper, isValid ? '' : styles.error)}
                                placeholder={translate('password')}
                                rounded="none"
                                value={p_.value.kioskMode?.exitCode ?? '95224'}
                                className={cn(showIcon ? styles.maskedInput : '')}
                                onChange={(value: string) => {
                                    p_.onChange(
                                        {
                                            ...p_.value.kioskMode,
                                            exitCode: value,
                                        },
                                        'kioskMode'
                                    )
                                }}
                                autocompletePasswordOff={true}
                                autocomplete={'new-password'}
                                icon={showIcon ? 'viewHide' : 'view'}
                                iconColor={getThemeStyleValue('ui', 'icon', 'disable') || defaultThemeStyles.disable}
                                iconTooltip={{
                                    title: showIcon ? translate('hidePassword') : translate('showPassword'),
                                }}
                                onIconClick={() => setShowIcon(!showIcon)}
                            />
                            <div className={cn(styles.hint, isValid ? '' : styles.error)}>
                                {translate('codeToKioskModeExitHint')}
                            </div>
                            <Dropdown
                                label={translate('timeForBlockAfterThreeAttempts')}
                                containerClassName={styles.inputWrapper}
                                value={p_.value.kioskMode?.invalidCodeLimit ?? 0}
                                options={TIME_LIMIT_OPTIONS}
                                onChange={function (option) {
                                    p_.onChange(
                                        {
                                            ...p_.value.kioskMode,
                                            invalidCodeLimit: option.id,
                                        },
                                        'kioskMode'
                                    )
                                }}
                            />
                        </>
                    )}
                </>
            )}
        </div>
    )
}

export default React.memo(DeviceSettingsKioskMode)
